module.exports = __webpack_public_path__ + "static/media/icon-folder.ba16632c.svg";